import { storeDokter } from "@/store/modules/dokter";
import { storeFaskes } from "@/store/modules/faskes";
import MasterReferensi from "@/store/modules/new/MasterReferensi";
import { storePerawat } from "@/store/modules/perawat";
import { storeUnit } from "@/store/modules/unit";
import { userModule } from "@/store/modules/user";

async function getReferenceData() {
  console.log("get reference data...");
  if (!storeDokter.list.length || !storeDokter.listAll.length) {
    storeDokter.act_dokter_all();
  }

  if (!storePerawat.listPerawat.length) {
    storePerawat.actListPerawatall();
  }

  if (!storePerawat.listKaryawan.length) {
    storePerawat.actListKaryawanAll();
  }

  if (!storeUnit.unitPagi.length) {
    storeUnit.act_on_all_pagi();
  }

  if (!storeFaskes.faskes.length) {
    storeFaskes.getFaskesList();
  }

  if (!MasterReferensi.caraKeluar.length) {
    MasterReferensi.getCaraKeluarList();
  }
}

let preferenceRequest: Promise<void> | null = null;

async function getUserPreferenceData() {
  console.log("get preference....");

  if (userModule.preference) {
    return;
  }

  if (!preferenceRequest) {
    preferenceRequest = userModule.getPreference().finally(() => {
      preferenceRequest = null;
    });
  }

  await preferenceRequest;
}

export { getReferenceData, getUserPreferenceData };
